export default __webpack_public_path__ + "static/media/icon3dcode2.c7b084d6.png";